<audio  loop><source [src]="audio.src" /></audio> 
<button (click)="audio.play()">Play</button>
<button (click)="audio.pause()">Pause</button>
